module.exports = __webpack_public_path__ + "static/media/stadion_small - Copy.f99e537e.jpg";